import { fetchAuthSession } from 'aws-amplify/auth';

function root_url() {
  if (window.location.host.includes('localhost')) {
    return 'https://uatapi.vangemert.dev'
  }
  return 'https://api.vangemert.dev'
}

function wss_root_url() {
  if (window.location.host.includes('localhost')) {
    return 'wss://uatwebsocket.vangemert.dev'
  }
  return 'wss://websocket.vangemert.dev'
}

export function get_api_tokens() {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching GET API tokens')
      fetch(root_url() + "/api_token", { headers })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}


export function create_api_token() {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching POST API token')
      fetch(root_url() + "/api_token", {
        method: 'POST',
        headers: headers
      })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}


export function delete_api_token(api_token_id) {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching DELETE API token')
      fetch(root_url() + "/api_token/api_token_id/" + api_token_id, {
        method: 'DELETE',
        headers: headers
      })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export function get_dashboards() {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching GET dashboards')
      fetch(root_url() + "/dashboard", { headers })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export function get_graph_data(dashboard_id, start_datetime, end_datetime) {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching GET graph data')
      fetch(root_url() + "/dashboard/" + dashboard_id + "/data/graph/start_datetime/" + start_datetime + "/end_datetime/" + end_datetime, { headers })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export async function fetch_auth_token() {
  const session = await fetchAuthSession();
  if (!session?.tokens?.idToken) {
    console.debug('Missing session tokens');
    throw new Error('Unauthorized: No session tokens available');
  }
  return session.tokens.idToken;
}

export async function api_request(endpoint, method = 'GET', body = null) {
  try {
    const token = await fetch_auth_token();
    const headers = {
      "Authorization": `Bearer ${token}`
    };

    const options = {
      method,
      headers,
      ...(body && { body: JSON.stringify(body) })
    };

    console.debug(`Fetching ${method} ${endpoint}`);
    const response = await fetch(root_url() + endpoint, options);

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('API request error:', error);
    return null;
  }
}

export function post_quotation(uuid) {
  let url = '/quotation?uuid=' + uuid;
  return api_request(
      url,
      'POST',
  );
}

/**
 * Persistent WebSocket connection manager (no authentication).
 * Usage:
 *   const ws = get_ws_connection('/ws/path');
 *   ws_send(ws, {foo: 'bar'}, (msg) => { ... });
 */
const ws_connections = {};

/**
 * Get or create a persistent WebSocket connection for an endpoint.
 * @param {string} endpoint - The WebSocket endpoint (relative to root_url, e.g. '/ws/path').
 * @returns {WebSocket} The WebSocket connection.
 */
export function get_ws_connection(endpoint) {
  // Convert HTTP(S) root_url to WS(S)
  let base = wss_root_url();
  const url = base + endpoint;
  if (ws_connections[url] && ws_connections[url].readyState !== WebSocket.CLOSED) {
    return ws_connections[url];
  }
  ws_connections[url] = new WebSocket(url);
  return ws_connections[url];
}
